module.exports = __webpack_public_path__ + "static/media/10.f32f658a.png";